



import BaseComponent from '@/components/base-component.vue';
import { EsqueciSenhaIniciarResult, EsqueciSenhaValidarResult } from '@/interfaces/user';
import Component from 'vue-class-component';
import * as service from '@/services/auth';
import { HOME_PATH } from '@/views/home/routes';

@Component
export default class BaseAccess extends BaseComponent {

  public STEP_CONFIRM_CPF_EMAIL = "SCCE";
  public STEP_CONFIRM_SMS_CODE = "SCSC";
  public STEP_JUSTIFY = "SJ";
  public STEP_NEW_PASSWORD = "SNP";

  public form: any = {
    valid: false,
    rules: {},
  };

  public step = this.STEP_CONFIRM_CPF_EMAIL;
  public esqueciSenhaIniciarResult: EsqueciSenhaIniciarResult = null;
  public msg: string = null;
  public msgErro: string = null;
  public validarResult: EsqueciSenhaValidarResult = null;

  public formControls: any = {};

  public $refs!: {
    form: HTMLFormElement;
  };

  public user: any = {};

  public esqueciSenhaValidar(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.msg = null;
    this.msgErro = null;
    this.loader.start('Validando...');

    service.forgotPasswordValid(this.esqueciSenhaIniciarResult.uuid, this.user.validationCode).subscribe(
      (res) => {
        this.validarResult = res;
        if (res.justificarFaltaUso) {
          this.step = this.STEP_JUSTIFY;
          this.msg = res.mensagemJustificar;
          setTimeout(() => {
            this.$refs['user.justification'].focus();
          }, 200);
        } else {
          this.step = this.STEP_NEW_PASSWORD;
          setTimeout(() => {
            this.$refs['user.novaSenha'].focus();
          }, 200);
        }
        this.loader.stop();
      },
      (error) => {
        this.$refs['user.validationCode'].focus();
        this.msgErro = error.data.message;
        this.timeoutResetMsgErro();
        this.loader.stop();
      },
    );
  }

  public esqueciSenhaDefinir(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.msg = null;
    this.msgErro = null;
    this.loader.start('Processando...');

    service.forgotPasswordDefine(this.esqueciSenhaIniciarResult.uuid, this.user.validationCode, this.user.novaSenha).subscribe(
      (res) => {
        this.loader.stop();
        const action = () => {
          this.loader.start('Logando...');
          service.login(this.esqueciSenhaIniciarResult.cpfCrm, this.user.novaSenha).subscribe((res) => {
            setTimeout(() => {
              this.loader.stop();
              window.location.href = HOME_PATH;
            }, 200);
          });
        };
        this.loader.stop();
        this.dialog.show('alert', 'Sucesso', 'Sua senha de acesso foi definida com sucesso.', 'Ok', action, '', null);
      },
      (error) => {
        this.msgErro = error.data.message;
        this.timeoutResetMsgErro();
        this.loader.stop();
      },
    );
  }

  timeoutMsgErro = null;
  timeoutResetMsgErro() {
    clearTimeout(this.timeoutMsgErro);
    this.timeoutMsgErro = setTimeout(() => {
      this.msgErro = null;
    }, 5000);
  }
}
